export const productGetters = {
  allProducts: (state) => {
    return state.products;
  },
  productById: (state, getters) => (id) => {
    if (getters.allProducts.length > 0) {
      return getters.allProducts.filter(p => p.id === id)[0];
    }
    return state.product;
  },
  allProductCategories: (state) => {
    return state.productCategories;
  },
};

export const authorisationGetters = {
  token: (state) => {
    return state.token;
  },
};

export const contentGetters = {
  getHomepageContent: (state) => {
    return state.pageContent;
  },
  getTopNavigation: (state) => {
    return state.topNavigation;
  },
  getSideNavigation: (state) => {
    return state.sideNavigation;
  },
  getContent: (state) => {
    return state.pageContent;
  },
  getCurrentPage: (state) => {
    return state.currentPage;
  },
};



// WEBPACK FOOTER //
// ./src/store/getters.js